import styled from "styled-components";

export const Container = styled.div`
  grid-area: banner;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  position: unset !important;

  .image {
    object-fit: cover;
    width: 100% !important;
    height: 250px !important;
    position: relative !important;
  }
`;

interface IInfoBannerProps {
  isIncrease: boolean;
  isMobile: boolean;
}

export const InfoBanner = styled.div<IInfoBannerProps>`
  top: 50%;
  left: 50%;

  max-width: 617px;
  height: ${({ isIncrease }) => (isIncrease ? "250px" : "235px")};
  position: relative;
  width: 100%;
  display: flex;

  transform: translate(-50%, -50%) scale(.7);

  border-radius: 8px;
  background: #fff;
  z-index: 9999;
  .col-2 {
    p{
      letter-spacing: 5px;
    }
  }
  /* card planos */
  box-shadow: 8px 7px 16px 0px rgba(0, 0, 0, 0.16);

  .col-1 {
    width: 30%;
    display: flex;
    top: 25%;
    position: relative;
    justify-content: center;
  }

  .col-2 {
    width: 70%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 1rem;
    flex: 1 0 0;
  }

  @media (max-width: 960px) {
    max-width: 80%;
    .col-1 {
      display: none;
    }

    .col-2 {
      width: 100%;
    }
  }

  @media (max-width: 620px) {
    top: 90%;

  }

  .title_wrapper {
    p {
      color: var(--primary-links-blue, #004a80);

      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%;
    }
  }

  .description_wrapper {
    p {
      color: var(--primary-text-black, #0B0C0C);

      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%; 
    }
  }

  .title_wrapper {
    width: 100%;
    display: flex;
  }

  .content_wrapper {
    padding: 2rem;

    .title {
      text-align: center;
    }
  }

  h1,
  p {
    color: black;
  }

  h1 {
    font-size: 48px;
    line-height: 52.8px;
  }

  p {
    font-size: 26px;
    line-height: 31.2px;
  }

  .info_text_banner {
    padding: 0 1rem 1rem 0;
  }

  @media (max-width: 820px) {
    .content_wrapper {
      padding: 1rem;
    }

    h1 {
      font-size: ${({ isMobile }) => (isMobile ? "20px" : "30px")};
      line-height: 38.4px;
    }

    p {
      font-size: 16px;
      line-height: 26.4px;
    }
  }

  @media (max-width: 280px) {
    h1 {
      font-size: 22px;
      line-height: 28.4px;
    }

    p {
      font-size: 12px;
      line-height: 16.4px;
      white-space: nowrap;
    }
  }
`;
